export { default as TagManager } from './TagManager/TagManager';
export type { TagManagerProps } from './TagManager/TagManager';
